export const ZZ_WORK_ORDER_TYPE_SERVICE = '01';
export const ZZ_WORK_ORDER_TYPE_COLLECTION_TRANSPORTATION = '01';
export const ZZ_WORK_ORDER_TYPE_COLLECTION_TRANSPORTATION_DISPOSAL = '03';
export const ZZ_WORK_ORDER_TYPE_DISPOSAL = '04';
export const ZZ_WORK_ORDER_TYPE_DISCHARGE = '05';
export const ZZ_WORK_ORDER_TYPE_TRANSSHIPMENT_STORAGE = '06';
export const ZZ_WORK_ORDER_TYPE_OTHERS = '07';
